import { ChevronSmallRightIcon, ChevronSmallLeftIcon, ChevronSmallDownIcon, CalendarIcon, ClockIcon } from '../../icons/index.js';
import { jsx } from 'react/jsx-runtime';

const MuiDatePickerOverrides = {
  MuiDatePicker: {
    defaultProps: {
      slots: {
        openPickerIcon: CalendarIcon,
        switchViewIcon: ChevronSmallDownIcon
      },
      slotProps: {
        openPickerButton: {
          edge: 'start'
        }
      }
    }
  },
  MuiDateTimePicker: {
    defaultProps: {
      ampm: false,
      slots: {
        openPickerIcon: CalendarIcon,
        switchViewIcon: ChevronSmallDownIcon
      },
      slotProps: {
        openPickerButton: {
          edge: 'start'
        }
      }
    }
  },
  MuiPickersArrowSwitcher: {
    defaultProps: {
      slots: {
        leftArrowIcon: ChevronSmallLeftIcon,
        rightArrowIcon: ChevronSmallRightIcon
      }
    },
    styleOverrides: {
      root: _ref => {
        let {
          theme
        } = _ref;
        return {
          '.MuiTypography-subtitle1': {
            ...theme.typography.body02
          }
        };
      }
    }
  },
  MuiPickersCalendarHeader: {
    styleOverrides: {
      label: _ref2 => {
        let {
          theme
        } = _ref2;
        return {
          ...theme.typography.body02
        };
      }
    }
  },
  MuiPickersYear: {
    styleOverrides: {
      root: _ref3 => {
        let {
          theme
        } = _ref3;
        return {
          '.MuiPickersYear-yearButton': {
            ...theme.typography.body01
          }
        };
      }
    }
  },
  MuiDateTimePickerTabs: {
    defaultProps: {
      timeIcon: /*#__PURE__*/jsx(ClockIcon, {}),
      dateIcon: /*#__PURE__*/jsx(CalendarIcon, {})
    }
  },
  MuiPickersToolbar: {
    styleOverrides: {
      root: _ref4 => {
        let {
          theme
        } = _ref4;
        return {
          '.MuiTypography-overline': {
            ...theme.typography.caption
          },
          '.MuiTypography-root': {
            fontFamily: theme.typography.fontFamily
          }
        };
      }
    }
  }
};

export { MuiDatePickerOverrides };
